export const supplementDetails = [
  {
    qNum: 'C5b',
    entity: ['familyHistory', 'familyConditions'],
    props: [
      {
        name: 'member',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'condition',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'ageAtOnset',
        qText: 'Age at Onset',
        showAnswer: true,
      },
      {
        name: 'type',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCAttack',
        qText:
          'Heart attack, Stroke, Myocardial Infarction, Transient Ischemic Attack, Cardiomyopathy (Heart Muscle Problem) or other Heart Failure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory', 'hadHCAttackDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCAbnormalBeat',
        qText: 'Abnormal heartbeat / atrial fibrillation',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCABFibrillation',
        qText: 'Do you have a history of atrial fibrillation or atrial flutter?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCABFTreatment',
        qText:
          'Has your abnormal heart beat been treated with medication, surgery or electrical shock (cardioversion)?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCABFTFainted',
        qText: 'Did your abnormal heart beat ever cause you to faint or lose consciousness?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory', 'hadHCAbnormalBeatDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCHypertension',
        qText: 'High blood pressure / hypertension',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCHMedication',
        qText: 'Are you taking medication to control your hypertension or high blood pressure?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory', 'medsHCH'],
    props: [
      {
        name: 'rxName',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory', 'hadHCHMedicationDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'bpMeasurements',
        qText: 'Do you know your current blood pressure measurements?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'systolic',
        qText: 'Systolic',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'diastolic',
        qText: 'Diastolic',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCMurmur',
        qText: 'Heart Murmur or Heart Valve Problem (including Mitral Valve Prolapse)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCMAdviseECG',
        qText: 'Have you been advised to have your heart periodically tested with imaging (echocardiogram)?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCMAdviseSurgery',
        qText: 'Have you been advised to have surgery for your heart murmur or heart valve problem?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCMAdviseMeds',
        qText:
          'Have you been advised to take medication or restrict your activity due to your heart murmur or heart valve problem?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory', 'hadHCMurmurDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCPericarditis',
        qText: 'Pericarditis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCPMultipleEpisodes',
        qText: 'Have you had more than one episode?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCPFullyRecovered',
        qText: 'Have you fully recovered?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory', 'hadHCPericarditisDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCBenign',
        qText: 'Varicose Veins\nVenous Insufficiency',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCOther',
        qText: 'Other/ Not Sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10a',
    entity: ['personalHistory', 'hadHCOtherDiagnosis'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10b',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCElevatedNow',
        qText: 'Do you currently have elevated cholesterol levels?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10b',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadHCKnowLevels',
        qText: 'Do you know your cholesterol levels?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10b',
    entity: ['personalHistory'],
    props: [
      {
        name: 'cholesterolTotal',
        qText: 'What is your total cholesterol',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10b',
    entity: ['personalHistory'],
    props: [
      {
        name: 'cholesterolHDL',
        qText: 'What is your HDL',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10c',
    entity: ['personalHistory', 'hadCancerDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBDAnemia',
        qText: 'Anemia',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBDAnemiaType',
        qText: 'Which type of anemia?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasBDAnemiaResolved',
        qText: 'Is your anemia currently resolved or controlled with oral iron pills/supplements?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory', 'hasBDAnemiaResolvedDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBDAnemiaBleeding',
        qText: 'Is your iron deficiency due to chronic bleeding other than menstrual bleeding?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory', 'hadBDAnemiaBleedingDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasBDAnemiaControlled',
        qText: 'Is your anemia adequately controlled with vitamin B12 supplements (oral or injected)?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory', 'hasBDAnemiaControlledDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasBDAnemiaSymptoms',
        qText: 'Do you currently have symptoms related to your anemia?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory', 'hasBDAnemiaSymptomsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBDSpleen',
        qText:
          'Overactive spleen (hypersplenism), low platelet count (thrombocytopenia) or ITP (idiopathic thrombocytopenic purpura)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory', 'hadBDSpleenDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBDClotting',
        qText: 'Problems with blood clotting, easy or excessive bleeding, or coagulation defects (hemophilia)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory', 'hadBDClottingDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBDHemochromatosis',
        qText:
          'Hemochromatosis\nIron or Vitamin Deficiency (without Anemia)\nThalassemia Trait or Sickle Cell Trait (without Anemia)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBDOther',
        qText: 'Other/Not Sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10d',
    entity: ['personalHistory', 'otherDiagnosisis'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBDAneurysm',
        qText: 'Brain aneurysm or bleeding',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadBDAneurysmDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBTumor',
        qText: 'Brain tumor',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBTumorDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBEncephalitits',
        qText: 'Encephalitits or meningitis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasDBRecovered',
        qText: 'Did you recover and did your doctor say you are neurologically normal now?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasDBRecovered2Years',
        qText: 'Did you fully recover from this episode more than 2 years ago?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBEncephalititsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBSeizures',
        qText: 'Epilepsy or seizures',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'medsDBSeizures',
        qText: 'How many medications do you currently take for your seizures?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBSiezuresLast5Years',
        qText: 'Was your last seizure more than 5 years ago?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBSeizuresDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBMigranes',
        qText: 'Headaches or migraines',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBMDisabilityPayments',
        qText: 'Have you received disability payments within the past 12 months for your headaches/migraines?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBMDisabilityPaymentsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBMS',
        qText: 'Multiple Sclerosis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBMSDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBNeuropathy',
        qText: 'Neuropathy (Chronic or Inflammatory)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBNeuropathyDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBParkinsons',
        qText: "Parkinson's Disease",
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBParkinsonsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBSciatica',
        qText: 'Sciatica',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBStroke',
        qText: 'Stroke',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBStrokeDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBFainting',
        qText: 'Fainting (Syncope)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBFMultipleEpisodes',
        qText: 'Have you had more than one episode of fainting?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBFMultipleEpisodesDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBFLastYear',
        qText: 'Was your most recent episode of fainting more than one year ago?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBFLastYearDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBTIA',
        qText: 'Transient Ischemic Attack (TIA)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBTIADiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBHematoma',
        qText: 'Subdural Hematoma / Hematoma in the brain',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hadDBHematomaDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBTBI',
        qText: 'Traumatic brain injury',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDBTBILast5Years',
        qText: 'Did the injury occur more than 5 years ago?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasTBISymptomsOrMeds',
        qText: 'Do you currently have any symptoms or take any medication related to this injury?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'hasTBISymptomsOrMedsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadTBTourettes',
        qText: "Tourette's syndrome",
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadTBNotSure',
        qText: 'Other/Not Sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10e',
    entity: ['personalHistory', 'diagnosisTB'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOHospitalizedLast5Years',
        qText:
          'In the past 5 years, have you been hospitalized or been enrolled in a partial hospitalization due to an emotional disorder?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory', 'hadEOHospitalizedLast5YearsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOAlcoholism',
        qText: 'Alcoholism',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory', 'hadEOAlcoholismDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOADepression',
        qText: 'Anxiety or Depression',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOTreatment',
        qText: 'Are you currently undergoing treatment?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEODepressionSituationalOnly',
        qText: 'Is your anxiety or depression situational only?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory', 'hadEOADepressionDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOHeartPalpitations',
        qText: 'Do you suffer from panic or stress induced chest pains or heart palpitations?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOADHD',
        qText: 'Attention Deficit Hyperactivity Disorder (ADHD)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOADHDChildhood',
        qText: 'Did your ADHD Symptoms begin in childhood (before age 10)?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEO',
        qText: 'Cognitive Impairment',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory', 'hadEODiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEODelusion',
        qText: 'Delusion',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory', 'hadEODelusionDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEODrugCounseling',
        qText: 'Drug Counseling',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory', 'hadEODrugCounselingDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOEatingDisorder',
        qText: 'Eating Disorder',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory', 'hadEOEatingDisorderDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOMajorDepression',
        qText: 'Major Depression',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory', 'hadEOMajorDepressionDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOPanicAttack',
        qText: 'Panic Attack',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOPAMedsLast2Years',
        qText:
          'Have you received medical care or been prescribed medication for panic attacks within the past 2 years?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory', 'hadEOPAMedsLast2YearsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOSuicideAttempt',
        qText: 'Suicide Attempt',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory', 'hadEOSuicideAttemptDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEOMinorDisorders',
        qText:
          'Brief Stress or Grief Reaction\n Performance Anxiety (public speaking, etc.)\n Seasonal Affective Disorder\n Social Phobia\n Simple Phobia (fear of snakes, etc.)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEONotSure',
        qText: 'Other / Not Sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10f',
    entity: ['personalHistory', 'diagnosisEONotSure'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10g',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEENTAcousicNeuroma',
        qText: 'Acoustic Neuroma',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10g',
    entity: ['personalHistory', 'hadEENTAcousicNeuromaDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10g',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEENTLeukoplakia',
        qText: 'Leukoplakia',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10g',
    entity: ['personalHistory', 'hadEENTLeukoplakiaDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10g',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEENTOpticNeuritis',
        qText: 'Optic Neuritis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10g',
    entity: ['personalHistory', 'hadEENTOpticNeuritisDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10g',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEENTNotSure',
        qText: 'Other / Not Sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10g',
    entity: ['personalHistory', 'diagnosisEENTNotSure'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDSarcoidosis',
        qText: 'Sarcoidosis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory', 'hadRDSarcoidosisDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDCOPD',
        qText: 'Chronic Obstructive Pulmonary Disease (COPD)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory', 'hadRDCOPDDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDEmphysema',
        qText: 'Emphysema',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory', 'hadRDEmphysemaDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDAsthma',
        qText: 'Asthma',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDAHospitalizedLast1Year',
        qText: 'Have you been hospitalized (kept overnight in the hospital) in the past year?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory', 'hadRDAHospitalizedLast1YearDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDAERLast1Year',
        qText: 'Have you visited the emergency department in the past year for your asthma?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory', 'hadRDAERLast1YearDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasRDAMeds',
        qText: 'Are you currently taking daily steroid pills, such as prednisone, for your asthma?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory', 'hasRDAMedsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDPulmonaryNodule',
        qText: 'Pulmonary Nodule',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory', 'hadRDPulmonaryNoduleDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasRDApnea',
        qText: 'Sleep Apnea',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory', 'hasRDApneaDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasRDCPAP',
        qText: 'Are you currently being treated with CPAP?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasRDCPAPLast6Months',
        qText: 'Have you been using CPAP for more than 6 months?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasRDBronchitis',
        qText: 'Bronchitis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasRDBRecovered',
        qText: 'Have you fully recovered?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDPneumonia',
        qText: "Pneumonia or Legionnaire's disease",
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasRDPRecovered',
        qText: 'Did you fully recover without complications?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory', 'hasRDPRecoveredDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDTuberculosis',
        qText: 'Tuberculosis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasRDTRecovered',
        qText:
          'Have you fully recovered without complications and are you no longer taking medications for tuberculosis?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory', 'hadRDTuberculosisDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDInfluenza',
        qText: 'Influenza\n Intermittent Cough/Cold\n Seasonal or Perennial Allergies',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDOther',
        qText: 'Other/Not sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10h',
    entity: ['personalHistory', 'diagnosisRDOther'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDAnorectalFistula',
        qText: 'Anorectal fistula or sinus',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDCeliacDisease',
        qText: 'Celiac Disease',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDCeliacDiseaseDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDColonPolyp',
        qText: 'Colon polyp',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDColonPolypDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDChrons',
        qText: "Crohn's disease",
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDChronsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDColitusNonUlcerative',
        qText: 'Colitis (non ulcerative)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDColitusNonUlcerativeDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDColitusUlcerative',
        qText: 'Colitis (ulcerative)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDColitusUlcerativeDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDiverticulitis',
        qText: 'Diverticulitis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDDLast6Months',
        qText: 'Have you had an episode in the past 6 months?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDDLast6MonthsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDNAFLD',
        qText: 'Non-alcoholic fatty liver disease (NAFLD) or nonalcoholic steatohepatitis (NASH)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDNAFLDDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDLiverBiopsy',
        qText: 'Have you ever been advised to have a biopsy of your liver?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDGastritis',
        qText: 'Gastritis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDHepititis',
        qText: 'Hepatitis B, C, or D',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDHepititisDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDPancreaticInflamation',
        qText: 'Pancreatic abscess or cysts',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDPancreaticInflamationDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDPancreatitis',
        qText: 'Pancreatitis (pancreatic inflammation)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDPancreatitisDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDUlcer',
        qText: 'Ulcer',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDURecovered',
        qText: 'Is/are your ulcer(s) completely healed?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDURecoveredDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDWeightLossSurgery',
        qText: 'Weight Loss Surgery',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'hadDDWeightLossSurgeryDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadDDBenign',
        qText:
          'Anorectal Abscess or Cyst\n Appendicitis\n Diverticulosis\n Food (Lactose, Gluten, Etc.) Intolerance, Food Allergy\n Gallbladder Pain\n Gallstones\n Gastroesophageal Reflux Disease (GERD)\n Hemorrhoids\n Hepatitis A or E, fully recovered\n Hiatal Hernia\n High Levels of Bilirubin (Hyperbilirubinemia)\n Inguinal (Groin) Hernia\n Intermittent or Chronic Constipation\n Intermittent Diarrhea\n Irritable Bowel Syndrome or Irritable Bowel Disease (IBS)\n Rectal Prolapse',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBDNotSure',
        qText: 'Other/Not sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10i',
    entity: ['personalHistory', 'diagnosisDDOther'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBMDAmputationsFromTrauma',
        qText: 'Amputations (due to a trauma only)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory', 'hadBMDAmputationsFromTraumaDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBMDArthritis',
        qText: 'Arthritis (including rheumatoid arthritis, osteoarthritis, and polyarthritis)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadBMDAType',
        qText: 'What type of arthritis do you have?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory', 'hadBMDATypeDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasBMDMeds',
        qText: 'Do you take any prescription medication for your arthritis?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory', 'hasBMDMedsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasBMDDisabilityBenefits',
        qText: 'Do you currently receive disability benefits for your arthritis?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory', 'hasBMDDisabilityBenefitsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasBMDOsteoporosis',
        qText: 'Osteoporosis or osteopenia',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory', 'hasBMDOsteoporosisDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasBMDBackPain',
        qText: 'Back pain',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasBMDBPMeds',
        qText: 'Are you currently taking prescription medication for your back pain?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasBMDPagets',
        qText: "Paget's disease of the bone",
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory', 'hasBMDPagetsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasBMDBenign',
        qText:
          "Bone Fractures Due to Trauma\n Bursitis\n Gout\n Joint Laxity/Hypermobility\n Overuse Injury (Stress Fracture, Shin Splints, Etc.)\n Scoliosis\n Tendonitis/Tendonsosis\n Tennis/Golfer's Elbow (Epicondylitis)\n Rotator Cuff Problems\n Patellofemoral Pain/Chrondromalacia Patella",
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasBMDOther',
        qText: 'Other/ Not Sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10j',
    entity: ['personalHistory', 'diagosisBMDAOther'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDChronicFatigue',
        qText: 'Chronic fatigue syndrome or fibromyalgia',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasRDCFFunctionNormal',
        qText: 'Are you able to function normally?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDDepression',
        qText: 'Do you suffer from depression?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory', 'hadRDChronicFatigueDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDEpsteinBarr',
        qText: 'Epstein-Barr virus',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDEBOtherSymptoms',
        qText: 'Do you currently suffer from fatigue or other symptoms related to your virus?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory', 'hadRDEBOtherSymptomsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDLupus',
        qText: 'Systemic Lupus Erythematosus (SLE)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory', 'hadRDLupusDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDLymeDisease',
        qText: 'Lyme disease',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadRDLDSymptoms',
        qText: 'Do you currently have fatigue or any other symptoms associated with your Lyme disease?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasRDLDTreatment',
        qText: 'Are you currently receiving treatment related to Lyme disease?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasRDOther',
        qText: 'Other/ Not Sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10k',
    entity: ['personalHistory', 'diagnosisRMDOther'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasDTDiabetes',
        qText: 'Diabetes',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasDTDType',
        qText: 'What type of diabetes do/did you have?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory', 'diabetesDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasDTProlactinoma',
        qText: 'Prolactinoma',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory', 'hasDTProlactinomaDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasDTThyroidDisease',
        qText: "Thyroid disease (cysts, nodules, thyroidectomy, Grave's, Hashimotos etc.)",
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasDTTStable',
        qText: 'Is your condition treated and stable?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory', 'hasDTTStableDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasDTTImageBiopsy',
        qText: 'Have you been advised to have periodic imaging or biopsy of a thyroid cyst, nodule or tumor?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory', 'hasDTTImageBiopsyDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasDTNotSure',
        qText: 'Other / Not sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10l',
    entity: ['personalHistory', 'DiagnosisisDTNotSure'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadNephritisLast2Years',
        qText: 'Acute nephritis, within the past 2 years',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory', 'hadNephritisLast2YearsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadNephritisMoreThanLast2Years',
        qText: 'Acute Nephritis, more than 2 years ago',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory', 'hadNephritisMoreThanLast2YearsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDBladderStones',
        qText: 'Bladder stones (calculi)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDGlomerulonephiritis',
        qText: 'Glomerulonephritis or Nephropathy',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory', 'hadUTDGlomerulonephiritisDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDKidneyStones',
        qText: 'Kidney stones',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDKidneyStonesMultiple',
        qText: 'Have you had them more than once?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasUTDNormalKidney',
        qText: 'Do you currently have normal kidney function without any obstrution or infection?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory', 'hasUTDNormalKidneyDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDRenalFailure',
        qText: 'Kidney failure / renal insufficiency / dialysis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory', 'hadUTDRenalFailureDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDPyelonephiritis',
        qText: 'Kidney infection (pyelonephritis)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTStructural',
        qText:
          'Do you have any known issues with your urological anatomy (for example: strictures or an abnormal ureter)?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory', 'hadUTStructuralDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDKidneyRecovered3Months',
        qText: 'Was your kidney infection treated and cured more than 3 months ago?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDProteinuria',
        qText: 'Proteinuria (protein in the urine on more than one occasion)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory', 'hadUTDProteinuriaDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDRenalCyst',
        qText: 'Renal cysts',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDRCMultiple',
        qText: 'Do you have a single cyst or multiple cysts?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory', 'hadUTDRCMultipleDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDBenign',
        qText:
          'Childhood kidney reflux (vesicoureteral reflux)\n Congential solitary kidney, horseshoe kidney\n Enlarged Prostate Gland/Prostatic Hyperplasia\n Incontinence\n Prostatitis\n Urinary Tract Infection or Cystitis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadUTDNotSure',
        qText: 'Other / Not sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10m',
    entity: ['personalHistory', 'DiagnosisUTDNotSure'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10n',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadSDPsoriasis',
        qText: 'Psoriasis',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10n',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadSDArthritis',
        qText: 'Do you have arthritis or psoratic arthritis?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10n',
    entity: ['personalHistory', 'hadSDArthritisDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10n',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasSDMeds',
        qText: 'Are you undergoing any treatment other than the use of topical medications?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10n',
    entity: ['personalHistory', 'hasSDMedsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10n',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hasSDOther',
        qText: 'Other / Not sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10n',
    entity: ['personalHistory', 'DiagnosisSDNotSure'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10p',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadIDCervicitis',
        qText: 'Cervicitis, endometriosis, or pelvic inflammatory disease',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10p',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadIDFibrocystic',
        qText: 'Fibrocystic disease of the breast',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10p',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadIDOvarianCyst',
        qText: 'Ovarian cyst',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10p',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadIDOBenign',
        qText: 'Is it benign?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10p',
    entity: ['personalHistory', 'hadIDOBenignDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10p',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadIDPolycystic',
        qText: 'Polycystic ovarian syndrome',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10p',
    entity: ['personalHistory', 'hadIDPolycysticDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10p',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadIDCongenitalMalform',
        qText:
          'Congenital malformation of the genital tract\n Ovarian Torsion\n Ectopic Pregnancy\n Papilloma of the Female Genital Tract\n Sexually Transmitted Disease (other than HIV or Syphillis)\n Uterine Fibroid\n Uterine Prolapse',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10p',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadIDNotSure',
        qText: 'Other / Not sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10p',
    entity: ['personalHistory', 'DiagnosisIDNotSure'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10q',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadCPBenign',
        qText: 'Multiple Miscarriages, Placental Problems, Bleeding or Labor/Delivery Issues',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10q',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadCPHighBloodPressure',
        qText: 'High Blood Pressure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10q',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadCPHeartLiverKidneyProblems',
        qText: 'Heart, Liver or Kidney Problems',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10q',
    entity: ['personalHistory', 'hadCPHeartLiverKidneyProblemsDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10q',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadCPSeizures',
        qText: 'Seizures',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10q',
    entity: ['personalHistory', 'hadCPSeizuresDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10q',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadCPGestationalDiabities',
        qText: 'Gestational Diabetes',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10q',
    entity: ['personalHistory', 'hadCPGestationalDiabitiesDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C10q',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadCPNotSure',
        qText: 'Other/Not Sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C10q',
    entity: ['personalHistory', 'CPDetails'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C11b',
    entity: ['personalHistory', 'hadAlcoholAbuseDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C11ci',
    entity: ['personalHistory', 'bloodTransfusionDetails'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C11cii',
    entity: ['personalHistory', 'heartSurgeryDetails'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C11ciii',
    entity: ['personalHistory', 'otherSurgeryDetails'],
    props: [
      {
        name: 'description',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C12a',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadECGNormal',
        qText: 'Was your ECG result normal?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C12a',
    entity: ['personalHistory', 'hadECGNormalDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C13',
    entity: ['personalHistory'],
    props: [
      {
        name: 'hadEORoutine',
        qText:
          'Were all these exams, check-ups and/or evaluations performed for routine medical care (routine physicals, immunizations, routine gynecological care, etc.), acute limited illness (cough, cold, flu, sore throat, sinus infection, rashes, urinary infection, etc.), or minor musculoskeletal injury/pain (abrasions, contusions, lacerations, back/neck or joint injury, sprains, strains, etc.?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C14',
    entity: ['personalHistory', 'hadTreatmentOtherDiagnosis'],
    props: [
      {
        name: 'physician',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'date',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C15',
    entity: ['personalHistory', 'hadMedsOther'],
    props: [
      {
        name: 'rxName',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARATV',
        qText: 'All Terrain Vehicles (ATV), excluding Three-Wheel',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARATV3Wheel',
        qText: 'Three-Wheel All Terrain Vehicles (ATV)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Auto Crash',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARCDiveBomber',
        qText: 'Dive Bomber, Rollovers, "T" Bone',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Auto Crash',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARCDemolition',
        qText: 'Demolition, Destruction Derby, Figure "8" Demolition',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Auto Crash',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARCOther',
        qText: 'Other/Not Sure',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Kart Racers (Go-Cart)',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARGCSprint',
        qText: 'Sprint',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Kart Racers (Go-Cart)',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARGCEnduro',
        qText: 'Enduro',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Kart Racers (Go-Cart)',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARGCFormula',
        qText: 'Formula Kart Experiment (FKE)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Kart Racers (Go-Cart)',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARGCMidget',
        qText: 'Midget (other than Full Size)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Kart Racers (Go-Cart)',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARGCMini',
        qText: 'Mini car',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Off Road',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARORDesert',
        qText: 'Desert (incl. Baja, Dune, Trail) - U.S. Only',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Off Road',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARORRally',
        qText: 'Long Distance, Rally - U.S. Only',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Off Road',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avAROROther',
        qText: 'Other or Outside U.S.',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing - Off Road',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avARRally',
        qText: 'Rally Racing (Local Events Only)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Auto Racing',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avAROtherDetails',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avBalloning',
        qText: 'Ballooning',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avBigGame',
        qText: 'Big game hunting',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avBobsledding',
        qText: 'Bobsledding (Competitive or Professional)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avBoxing',
        qText: 'Boxing (Amateur Only)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avBoxingPro',
        qText: 'Boxing (Professional)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Bungee Jumping',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avBungeeNow',
        qText: 'Do you plan on bungee jumping within the next two years?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Hang Gliding',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avHangGlidingLow',
        qText:
          'Is your hang gliding limited to amateur, club affiliated jumps in minimal danger areas less than 500 feet altitude with no soaring?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Hang Gliding',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avHangGlidingOften',
        qText: 'Do you hang glide fewer than 25 times per year?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avHeliSkiing',
        qText: 'Heli skiing',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avMartialArts',
        qText: 'Martial Arts (Amateur or Instructor)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avMartialArtsPro',
        qText: 'Martial Arts (Professional Competition)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avMotorboatRacing',
        qText: 'Motorboat / powerboat racing',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B13 - Motorcycle Racing',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avMRType',
        qText: 'What kind of motorcylces do you race?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Motorcycle Racing',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avMRGrandPrix',
        qText: 'Do you race Grand Prix up to 250cc?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Motorcycle Racing',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avMRDrag',
        qText:
          'Do you participate in drag racing, dragster division racing, road racing, speedway racing, or tourist trophy racing, or do you ever race outside the US?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Mountain Climing',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avMCRated',
        qText: 'Are all your climbs limited to difficulty levels of Class 1-4 of the Yosemite Decimal System (YDS)?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Scuba Diving',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avSDShallow',
        qText: 'Are your dives limited to 100 feet in depth?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Scuba Diving',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avSDBasicCert',
        qText: 'Is your certification limited to a resort or basic certification?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Scuba Diving',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avSDInfrequent',
        qText: 'Do you dive fewer than 50 times per year?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Skydiving/Ultralight',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avSDSoon',
        qText: 'Do you plan to skydive within the next two years?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Skydiving/Ultralight',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avSKDInfrequent',
        qText: 'Do you jump fewer than 25 times per year?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Skydiving/Ultralight',
    entity: ['riskFactors'],
    props: [
      {
        name: 'avSDAmateur',
        qText: 'Is all your skydiving limited to Amateur, USPA, no baton Passing, no delayed chute openings?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B13 - Other',
    entity: ['riskFactors', 'avOtherDetail'],
    props: [
      {
        name: 'type',
        qText: 'Type:',
        showAnswer: true,
      },
      {
        name: 'frequency',
        qText: 'Frequency:',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B2',
    entity: ['riskFactors'],
    props: [
      {
        name: 'mvLastDUI',
        qText: 'How many years has it been since your last DUI?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B2',
    entity: ['riskFactors'],
    props: [
      {
        name: 'mvDUIConvitions',
        qText: 'In the past 5 years, how many DUI convictions have you received?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B3',
    entity: ['riskFactors'],
    props: [
      {
        name: 'mvViolations',
        qText: 'In the past 5 years, how many moving violations have you received?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B3',
    entity: ['riskFactors'],
    props: [
      {
        name: 'mvAccidentAtFault',
        qText: 'At-Fault Accident',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B3 - At-Fault Accident',
    entity: ['riskFactors', 'mvAccidentAtFaults'],
    props: [
      {
        name: 'mvAccidentWhen',
        qText: '',
        showAnswer: true,
        suffix: 'ago',
      },
    ],
  },
  {
    qNum: 'B3',
    entity: ['riskFactors'],
    props: [
      {
        name: 'mvSpeeding',
        qText: 'Speeding Ticket',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B3',
    entity: ['riskFactors'],
    props: [
      {
        name: 'mySpeedingTicketCount',
        qText: 'How many speeding tickets have you received?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B3 - Speeding Ticket',
    entity: ['riskFactors', 'mySpeedingTickets'],
    props: [
      {
        name: 'mvSpeeding15Over',
        qText: 'Was this ticket for speeding more than 15 miles per hour over the speed limit?',
        showAnswer: true,
      },
      {
        name: 'mvSpeedingDate',
        qText: '',
        showAnswer: true,
        suffix: 'ago',
      },
    ],
  },
  {
    qNum: 'B3',
    entity: ['riskFactors'],
    props: [
      {
        name: 'mbReckless',
        qText: 'Careless/Reckless Driving',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B3 - Careless/Reckless Driving',
    entity: ['riskFactors', 'mbRecklessTickets'],
    props: [
      {
        name: 'mvRecklessDate',
        qText: '',
        showAnswer: true,
        suffix: 'ago',
      },
    ],
  },
  {
    qNum: 'B3',
    entity: ['riskFactors'],
    props: [
      {
        name: 'mvOther',
        qText: 'Other Moving Violation',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'B3 - Other Moving Violation',
    entity: ['riskFactors', 'mvOthers'],
    props: [
      {
        name: 'mvOtherWhen',
        qText: '',
        showAnswer: true,
        suffix: 'ago',
      },
      {
        name: 'mvOtherDetails',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'B4 - Convicted of driving with a suspended or revoked license',
    entity: ['riskFactors', 'mvDrivingWhileSuspendedCons'],
    props: [
      {
        name: 'mvDWSConvictionDate',
        qText: '',
        showAnswer: true,
        suffix: 'ago',
      },
    ],
  },
  {
    qNum: 'B10 - Travel',
    entity: ['riskFactors', 'ftCountries'],
    props: [
      {
        name: 'name',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'ftMexicoSpecific',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'departureDateWhen',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'departureDate',
        qText: '',
        showAnswer: true,
      },
      {
        name: 'duration',
        qText: '',
        showAnswer: true,
        suffix: 'Days',
      },
      {
        name: 'purpose',
        qText: '',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C6',
    entity: ['riskFactors'],
    props: [
      {
        name: 'usesCigarettes',
        qText: 'Cigarettes',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C6',
    entity: ['riskFactors'],
    props: [
      {
        name: 'usesCigars',
        qText: 'Cigars',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C6',
    entity: ['riskFactors'],
    props: [
      {
        name: 'usesPipe',
        qText: 'Other (Pipe, Chewing Tobacco, E-Cigarettes, Patch, Gum, Smoking Cessation Aids)',
        skipFalse: true,
      },
    ],
  },
  {
    qNum: 'C6',
    entity: ['riskFactors'],
    props: [
      {
        name: 'usesCigarsFrequency',
        qText: 'On average, how many cigars do you smoke per month?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C6',
    entity: ['riskFactors'],
    props: [
      {
        name: 'quitCigarrettesPeriod',
        qText: 'How many years has it been since you quit smoking cigarettes?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C6',
    entity: ['riskFactors'],
    props: [
      {
        name: 'quitCigarsPeriod',
        qText: 'How many years has it been since you quit smoking cigars?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C6',
    entity: ['riskFactors'],
    props: [
      {
        name: 'usedCigarsFrequency',
        qText: 'On average, how many cigars per month did you smoke at the time?',
        showAnswer: true,
      },
    ],
  },
  {
    qNum: 'C6',
    entity: ['riskFactors'],
    props: [
      {
        name: 'quitTobaccoPeriod',
        qText: 'How many years has it been since you quit using these other tobacco products?',
        showAnswer: true,
      },
    ],
  },
];
